import { render, staticRenderFns } from "./PaymentsView.vue?vue&type=template&id=aca80d60"
import script from "./PaymentsView.vue?vue&type=script&lang=ts"
export * from "./PaymentsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports